import React from 'react'
import { Header, Dropdown } from '..'
import TriggerRenderer from './TriggerRenderer'
import { Typography } from '@mui/material'

/**
 * CustomMenuDropdown component that renders a dropdown menu with customizable items
 *
 * @param {Object} props - Component props
 * @param {Object} props.menuItem - Configuration for the menu item
 * @param {Object} props.menuItem.trigger - Trigger configuration
 * @param {Array|string} props.menuItem.content - Content for the dropdown (array of menu items or HTML string)
 */
const CustomMenuDropdown = ({ menuItem }) => {
    if (!menuItem || !menuItem.trigger || !menuItem.content) return null

    const { trigger, content } = menuItem
    const isHtmlContent = typeof content === 'string'
    const menuItems = Array.isArray(content) ? content : []
    const isTextTrigger = trigger.type === 'text'

    const handleItemSelection = () => {
        // Handle item selection if needed
    }

    const renderDisplay = () => {
        return <TriggerRenderer trigger={trigger} />
    }

    // Determine the anchor position based on trigger type
    const anchorPosition = isTextTrigger
        ? { right: '-3rem', top: '5.4rem' }
        : { right: '-3rem', top: '5.4rem' }

    return (
        <Header.PopupMenu
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            disableScrollLock={true}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            displayIcon={renderDisplay()}
            anchorPosition={anchorPosition}
            showCone={true}
            width={isHtmlContent ? 'auto' : '24rem'}
        >
            {isHtmlContent ? (
                <div
                    style={{ padding: '1.6rem', minWidth: '20rem' }}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            ) : (
                menuItems.map((item, index) => (
                    <Dropdown.Item
                        key={`menu-item-${index}`}
                        onClick={handleItemSelection}
                        component={item.url ? 'a' : 'div'}
                        href={item.url}
                        target={item.url ? '_blank' : undefined}
                        rel={item.url ? 'noopener noreferrer' : undefined}
                    >
                        {item.icon && (
                            <TriggerRenderer
                                trigger={{
                                    type: item.icon.type,
                                    value: item.icon.value,
                                    style: {
                                        width: '2rem',
                                        height: '2rem',
                                        marginRight: '0.8rem',
                                        ...item.icon.style,
                                    },
                                }}
                            />
                        )}
                        <Typography component="span">{item.label}</Typography>
                    </Dropdown.Item>
                ))
            )}
        </Header.PopupMenu>
    )
}

export default CustomMenuDropdown
